// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__2xe2n","backBtn":"styles_backBtn__3_Fp3"};